import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=132f3b8c&scoped=true"
import script from "./TreeMenu.vue?vue&type=script&lang=js"
export * from "./TreeMenu.vue?vue&type=script&lang=js"
import style0 from "./TreeMenu.vue?vue&type=style&index=0&id=132f3b8c&prod&lang=less&scoped=true"
import style1 from "./TreeMenu.vue?vue&type=style&index=1&id=132f3b8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f3b8c",
  null
  
)

export default component.exports